import { useCallback, useMemo } from 'react';

export interface UseFormatNumberProps extends Intl.NumberFormatOptions {
  locale?: string | string[];
}

export const useFormatAmount = ({ locale = 'en-US', ...numberFormatOptions }: UseFormatNumberProps) => {
  const numberFormat = useMemo(() => new Intl.NumberFormat(locale, numberFormatOptions), [locale, numberFormatOptions]);

  return useCallback((value: number): string => numberFormat.format(value), [numberFormat]);
};
